import SelectStoreTab from "../../components/tabs/SelectStoreTab";
import "../../styles/payouts/payout.css";
import Template from "../Template";
import EachPayoutComponent from "./EachPayoutComponent";
import { useState, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import ChangePayout from "./ChangePayout";
import NoPayoutSetPage from "./NoPayoutSetPage";
import { getPayOutUrl } from "../../api/endpoints";
import PayoutDetails from "./PayoutDetails";
import Spinner from "../../components/uxCollections/Loaders";
import { refreshUserToken } from "../../tools/refreshToken";
import { useNavigate } from "react-router-dom";
import { BsBank, BsFilter } from "react-icons/bs";
import noPayoutImage from "../../assetsStatic/noPayoutYet.png";

const PayoutScreen = () => {
  const [openModal, setOpenModal] = useState(false);
  const [allPayout, setAllPayout] = useState(null);
  const [allPayoutCopy, setAllPayoutCopy] = useState(null);
  const [currentPayoutWithOutFilter, setCurrentPayoutWithOutFilter] = useState(null); //[]
  const [payOutTotal, setPayOutTotal] = useState(0);
  const [selectedPayout, setSelectedPayout] = useState(null);
  const [isLoading, setIsLoading] = useState(true); //[
  const [filterPayoutBasedOnStore, setFilterPayoutBasedOnStore] = useState({ storeName: "All stores", storeId: "1" });
  const [payOutStatusfilter, setPayOutStatusfilter] = useState("All"); //["all", "pending", "paid", "disputed", query", cancelled"]
  const [openMobilePayoutDetails, setOpenMobilePayoutDetails] = useState(false); //
  const { user } = useSelector((state) => state.webStoreUser);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    fetchPayOut();
  }, []);

  useLayoutEffect(() => {
    /* to filter based on store */
    if (allPayout) {
      if (filterPayoutBasedOnStore.storeName === "All stores") {
        setAllPayout(allPayoutCopy);
        setPayOutTotal(computeTotalPayOut(allPayoutCopy));
        /* reset secondary filter "
        all" */
        setCurrentPayoutWithOutFilter(allPayoutCopy);
        setPayOutStatusfilter("All");
      } else {
        let filteredPayout = allPayoutCopy.filter((payout) => {
          return payout.store.storeID === filterPayoutBasedOnStore.storeId;
        });
        setAllPayout(filteredPayout);
        setPayOutTotal(computeTotalPayOut(filteredPayout));
        setCurrentPayoutWithOutFilter(filteredPayout);
        setPayOutStatusfilter("All");
      }
    }
  }, [filterPayoutBasedOnStore]);

  const fetchPayOut = async () => {
    try {
      let response = await fetch(getPayOutUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (response.ok) {
        let payOut = await response.json();
        setAllPayout(payOut);
        setAllPayoutCopy(payOut);
        console.log(payOut);
        setPayOutTotal(computeTotalPayOut(payOut));
        setIsLoading(false);
      } else if (response.status === 400) {
        refreshUserToken(getPayOutUrl, fetchPayOut, navigate);
      }
    } catch (error) {
      console.log(error);
    }
  };

  /* payouts must be an array */
  const computeTotalPayOut = (payOuts) => {
    let total = 0;
    payOuts.forEach((payout) => {
      let payOutAmount = parseInt(payout.totalPrice) - parseInt(payout.commission);
      total += payOutAmount;
    });
    return total;
  };

  const showIntervalTab = () => {
    let tab = document.querySelector(".chooseInterval");
    tab.classList.toggle("showInterval");
  };

  const updatePayOutStatusFilter = (status) => {
    if (status === "all") {
      setAllPayout(currentPayoutWithOutFilter);
      setPayOutTotal(computeTotalPayOut(currentPayoutWithOutFilter));
      setPayOutStatusfilter("All");
      showIntervalTab();
    } else {
      let filteredPayouts = currentPayoutWithOutFilter.filter((payout) => {
        return payout.status === status;
      });
      setAllPayout(filteredPayouts);
      setPayOutTotal(computeTotalPayOut(filteredPayouts));
      setPayOutStatusfilter(status.charAt(0).toUpperCase() + status.slice(1));
      showIntervalTab();
    }
  };
  return (
    <>
      <Template>
        <h3 className='sRTitle22' style={{ marginBottom: "20px" }}>
          Payout
        </h3>

        {user.isPayOutMethodSet ? (
          isLoading ? (
            <div className='payoutContainer'>
              <Spinner position={"absolute"} backgroundColor={"#F9F9F9"} />
            </div>
          ) : (
            <div className='payoutContainer'>
              <div style={{ marginBottom: "16px" }} className='customerFilter'>
                <SelectStoreTab updateSelectedStore={setFilterPayoutBasedOnStore} resetFilter={true} disableStoreFilter={false} />
                <div className='searchEmployeediv'>
                  {/*    <input autoFocus={true} className='SearchTransact1 searchWarehouse' placeholder='Enter order ID' />
            <span>
             
            </span> */}
                </div>
              </div>
              <div className='timelinePayoutIDv sRTitle22'>
                <h5>Payment for fresh mart</h5>
                <div
                  style={{ padding: "3px 7px", alignItems: "center", gap: "4px", color: "#0E49B5", fontWeight: "600", cursor: "pointer" }}
                  className='TimelineTransactions'
                >
                  <BsFilter />
                  <span onClick={showIntervalTab}>{payOutStatusfilter}</span>
                  <div style={{ bottom: "-302px", width: "172px" }} id='ReceiveOrderInterval' className='chooseInterval'>
                    <p onClick={() => updatePayOutStatusFilter("all")}>All</p>
                    <p onClick={() => updatePayOutStatusFilter("pending")}>Pending</p>
                    <p onClick={() => updatePayOutStatusFilter("paid")}>Paid</p>
                    <p onClick={() => updatePayOutStatusFilter("disputed")}>Disputed</p>
                    <p onClick={() => updatePayOutStatusFilter("query")}>Query</p>
                    <p onClick={() => updatePayOutStatusFilter("cancelled")}>Cancelled</p>
                  </div>
                </div>
              </div>
              <div className='payoutdivSplit49 '>
                <div>
                  <div id='payoutPageTi' className='stockPageTitle '>
                    <p>Product</p>
                    <p>Date</p>

                    <p>Unit price ({user.userCountryCurrencySymbol})</p>

                    <p>Total price ({user.userCountryCurrencySymbol})</p>
                    <p>Payout ({user.userCountryCurrencySymbol})</p>
                    <p>status</p>
                  </div>
                  <div style={{ height: "82%" }} className='stockPageWrapper'>
                    {allPayout && allPayout.length > 0 ? (
                      allPayout.map((payout) => {
                        return (
                          <EachPayoutComponent
                            key={payout._id}
                            payout={payout}
                            selectedPayout={selectedPayout}
                            setSelectedPayout={setSelectedPayout}
                            setOpenMobilePayoutDetails={setOpenMobilePayoutDetails}
                          />
                        );
                      })
                    ) : (
                      <div className='noPayouts'>
                        <img src={noPayoutImage} />
                        <h3>No payout yet</h3>
                        <p>When you have a payout, it will appear here.</p>
                      </div>
                    )}
                  </div>
                  <div className='pagninationDIv'> .......</div>
                </div>
                <div>
                  {selectedPayout ? (
                    <PayoutDetails selectedPayout={selectedPayout} user={user} />
                  ) : (
                    <div className='payoutDetailDIv'>
                      {" "}
                      <div className='jurnwkxa23'> Nothing to show</div>{" "}
                    </div>
                  )}
                  <div className='paymentMethodDIV'>
                    <h5>Payment method</h5>

                    <div>
                      {user.payoutMethod.payoutMethod === "Bank transfer" ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "rgb(128, 74, 3)", fontWeight: "600" }}>
                          <BsBank />
                          <p style={{ margin: "10px 0", fontSize: "0.9rem" }}> {user.payoutMethod.payoutMethod} </p>
                        </div>
                      ) : (
                        <p style={{ margin: "10px 0", fontSize: "0.9rem" }}> {user.payoutMethod.payoutMethod} </p>
                      )}
                      <div className='paymentmethod123Ch'>
                        {user.payoutMethod.payoutMethod === "Bank transfer" ? ( // Bank transfer
                          <div>
                            <p>{user.payoutMethod.payoutAccountName}</p>
                            <p>{user.payoutMethod.payoutAccountNumber}</p>
                            <p>{user.payoutMethod.payoutBankName}</p>
                          </div>
                        ) : user.payoutMethod.payoutMethod === "PayPal" ? (
                          <div>Pay</div>
                        ) : (
                          <div>HubCoin</div>
                        )}
                        <p onClick={() => setOpenModal(true)} className='payoutButtouChange23'>
                          Change
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className='payoutTotalDIv23'>
                    <p>Total</p>
                    <p>
                      {user.userCountryCurrencySymbol} {payOutTotal.toLocaleString()}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <NoPayoutSetPage />
        )}

        {user.isPayOutMethodSet && (
          <div className='payoutTotalDIv23 fixedSh834847'>
            <p>Total</p>
            <p>
              {user.userCountryCurrencySymbol} {payOutTotal}
            </p>
          </div>
        )}

        {user.isPayOutMethodSet && (
          <div className='mobileViewPaymentMethod'>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h5>Payment method</h5>
              <p style={{ margin: "10px 0", fontSize: "0.9rem" }}> {user.payoutMethod?.payoutMethod} </p>
            </div>
            <div className='paymentmethod123Ch'>
              {user.payoutMethod?.payoutMethod === "Bank transfer" ? ( // Bank transfer
                <div>
                  <p>{user.payoutMethod?.payoutAccountName}</p>
                  <p>{user.payoutMethod?.payoutAccountNumber}</p>
                  <p>{user.payoutMethod?.payoutBankName}</p>
                </div>
              ) : user.payoutMethod?.payoutMethod === "PayPal" ? (
                <div>Pay</div>
              ) : (
                <div>HubCoin</div>
              )}
              <p onClick={() => setOpenModal(true)} className='payoutButtouChange23'>
                Change
              </p>
            </div>
          </div>
        )}
        {selectedPayout && openMobilePayoutDetails && (
          <MobilePayoutDetails selectedPayout={selectedPayout} user={user} closeModal={setOpenMobilePayoutDetails} />
        )}
        {openModal && <ChangePayout updateModal={setOpenModal} />}
      </Template>
    </>
  );
};

export default PayoutScreen;

const MobilePayoutDetails = ({ selectedPayout, user, closeModal }) => {
  return (
    <>
      <div className='payOutMobileWrapper' onClick={() => closeModal(false)}>
        <PayoutDetails selectedPayout={selectedPayout} user={user} />
      </div>
    </>
  );
};
